import { ContentType } from '@/@types/common'
import { type Post, PostAction } from '@/@types/post'
import { isEqual } from 'lodash-es'
import { Fragment, type HTMLAttributes, memo, useMemo } from 'react'
import PostCard from './PostCard'
import { usePostListContext } from './PostListContext'
import UserFollowPost from './UserFollowPost'

export interface CompositePostProps extends HTMLAttributes<HTMLDivElement> {
	data: Post
}

export default memo(function CompositePost({ data, ...props }: CompositePostProps) {
	const listContext = usePostListContext()
	const noTopic = listContext?.type === 'TOPIC'

	const content = useMemo(() => {
		if (!data || data.deleted) {
			return null
		}

		switch (data.type) {
			case ContentType.POST:
				return <PostCard data={data} noTopic={noTopic} />
			case ContentType.REPOST:
				return <PostCard data={data} noTopic={noTopic} />
			case ContentType.PERSONAL_UPDATE:
				switch (data.action) {
					case PostAction.USER_FOLLOW:
						return <UserFollowPost data={data} />
				}
				return null
			default:
				console.debug('暂不支持的动态类型')
				return <Fragment key="not-supported-post-type">{null}</Fragment>
		}
	}, [data, noTopic])

	return <div {...props}>{content}</div>
}, isEqual)
